import { useQuery } from '@tanstack/react-query';
import { gethCourses } from '../../../core/queries/course';

function useFetchCourses() {
  const { data, isError, error, isSuccess, isPending } = useQuery({
    queryKey: ['fetch-courses'],
    queryFn: () => gethCourses(),
    retry: false,
    refetchOnWindowFocus: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
  };
}

export { useFetchCourses };
